import { cn } from '@/shared/utils/utils';

function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="skeleton"
      className={cn('bg-accent dark:bg-slate-600/50 animate-pulse rounded-md', className)}
      {...props}
    />
  );
}

export { Skeleton };
